import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2, TrendingUp, Wallet, Clock, Layers, AlertCircle } from 'lucide-react';
import styles from './ComparisonSection.module.css';

const ComparisonSection = () => {
  const brandOrange = "#e87355";
  const brandBlue = "#5ba5e0";

  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        
        {/* --- HEADER --- */}
        <div className={styles.header}>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={styles.title}
          >
            Why <span className={styles.accent}>Ananta?</span>
          </motion.h2>
          <p className={styles.subTitle}>
            Because your competition is still doing this manually.
          </p>
        </div>

        <div className={styles.stackContainer}>
          
          {/* --- THE PROBLEM (COMPETITION) --- */}
          <motion.div 
            className={styles.problemCard}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className={styles.cardLabel}><AlertCircle size={14}/> THE OLD STRUGGLE</div>
            <h3 className={styles.cardHeading}>Manual Production</h3>
            
            <div className={styles.pointsList}>
              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div>
                  <strong>Expensive Anchors</strong>
                  <span className={styles.priceTag}>₹25k–₹50k/mo</span>
                </div>
              </div>
              
              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div><strong>High Studio Setup Costs</strong></div>
              </div>

              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div><strong>Delayed Production & Editing</strong></div>
              </div>
            </div>
          </motion.div>

          {/* --- THE SOLUTION (ANANTA) --- */}
          <motion.div 
            className={styles.solutionCard}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <div className={styles.popularBadge}>BETTER VALUE</div>
            <h3 className={styles.cardHeading}>Ananta AI Powerhouse</h3>
            
            <div className={styles.solutionGrid}>
              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandOrange}20`}}>
                  <Wallet color={brandOrange} size={22} />
                </div>
                <div>
                  <h4>Fraction of Cost</h4>
                  <p>Daily news videos without the massive payroll.</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandBlue}20`}}>
                  <Clock color={brandBlue} size={22} />
                </div>
                <div>
                  <h4>Consistent Output</h4>
                  <p>No more human delays. 24/7 reliability.</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandOrange}20`}}>
                  <Layers color={brandOrange} size={22} />
                </div>
                <div>
                  <h4>Scalable Production</h4>
                  <p>Grow from 1 to 100 videos effortlessly.</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandBlue}20`}}>
                  <TrendingUp color={brandBlue} size={22} />
                </div>
                <div>
                  <h4>Pro Branding</h4>
                  <p>National-TV visuals from the first second.</p>
                </div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;